module.exports = "<my-title my-label=\"$root.labels.account.accountOf(user.getUsername())\"\n  my-style=\"$root.styles.titles.center\"\n  my-level=\"1\">\n</my-title>\n\n<div class=\"container\">\n  <ul class=\"collection\">\n    <a class=\"collection-item\"\n      ng-click=\"item.go()\"\n      ng-repeat=\"item in accountMenu\"\n      ng-show=\"user.isAdmin() || !item.admin\">\n      <div>\n        {{item.label}}\n        <div class=\"secondary-content\">\n          <i class=\"material-icons\">send</i>\n        </div>\n      </div>\n    </a>\n  </ul>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./public/javascript/sygem/routing/account/templates/home.html
// module id = 1472
// module chunks = 0